module.exports = __webpack_public_path__ + "static/deslizadero-7acf70a1b3275fea9ae4ac53cb25b9d0.webp";